import { style } from "typestyle";

export const validation_error_style = style({
	position: 'absolute',
	margin: '0 0 0 1em',
	color: '#f46295',
	backgroundColor: 'white',
	padding: '0.2em',
	borderRadius: '0 0.2em 0.2em 0.2em',
})


export const validation_warn_style = style({
    borderColor: '#d90d0d',
})